<template lang="pug">
	.creative--text-base-audio-editor--popup
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="1080", :height="580", :title="$tCaption('SonicScribe')", :showMaximize="true")
			.creative--text-base-audio-editor--popup
				.text-base-audio-editor-content(ref="editorHolder")
					CreativeTextBasedAudioEditor(v-if="popupVisible", ref="editor", :track="track", @playing="v => isPlaying = v", :height="height", @disabled="v => disabled = !!v")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close')", @click="popupVisible = false", :disabled="disabled")
				DxButton(:text="$tCaption('Save')", @click="save", type="success", :disabled="disabled")
			template(slot="actions-left")
				DxButton(:text="isPlaying ? $tCaption('Stop') : $tCaption('Play')", @click="() => isPlaying ? $refs.editor.stop() : $refs.editor.play()", type="default", :icon="isPlaying ? 'square' : 'fas fa-play'", :disabled="disabled")
				DxButton(:text="$tCaption('Download')", @click="$refs.editor.download()", icon="fas fa-download", :disabled="disabled")
				DxButton(:text="$tCaption('Reset')", @click="$refs.editor.reset()", icon="fas fa-rotate-right", :disabled="disabled")
</template>

<script>
	import CreativeTextBasedAudioEditor from './CreativeTextBasedAudioEditor.vue';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import resizeObserver from 'resize-observer';

	export default {
		translationCategory: 'creative.CreativeTextBaseAudioEditorPopup',
		name: 'creative--text-base-audio-editor--popup',
		components: {
			Popup, DxButton, CreativeTextBasedAudioEditor
		},
		data() {
			return {
				popupVisible: false,
				track: null,
				isPlaying: false,
				height: 0,
				disabled: false
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeTextBaseAudioEditorPopup = this;
		},
		destroyed() {
			if (this.$unobserve) {
				this.$unobserve();
			}
		},
		methods: {
			calcHeight() {
				this.height = this.$refs?.editorHolder?.offsetHeight - 80;
			},
			show(track) {
				this.track = track;
				this.popupVisible = false;
				this.isPlaying = false;
				setImmediate(() => {
					this.popupVisible = true;
					this.$nextTick(() => {
						this.calcHeight();
						if (this.$unobserve) this.$unobserve();
						this.$unobserve = resizeObserver.observe(this, this.$refs?.editorHolder, this.calcHeight);
					});
				});
			},
			async save() {
				this.popupVisible = false;
				const wav = await this.$refs.editor.getWave();
				this.$emit('save', this.track, wav);
			}
		}
	};
</script>
<style lang='scss'>
	.creative--text-base-audio-editor--popup {
		.text-base-audio-editor-content {
			position: absolute;
			left: 0px;
			top: 0px;
			width: 100%;
			height: 100%;
		}
	}
</style>
